export default __webpack_public_path__ + "static/media/texture-wood-2x.b854c214.png";